import { Input } from '@angular/core';
import { Component, OnInit } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
    selector: 'app-gwall-hint',
    templateUrl: './gwall-hint.component.html',
    styleUrls: ['./gwall-hint.component.scss'],
    imports: [TranslatePipe]
})
export class GwallHintComponent implements OnInit {

  @Input() gwall: string;

  constructor() { }

  ngOnInit(): void {

  }
}
